"use client";

export default function EditIcon({ className = "", ...props }) {
  return (

<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}
    {...props} >
<path d="M35.1813 34.8541H4.27869" stroke="currentColor" strokeWidth="2.51718" strokeMiterlimit="10"/>
<path d="M7.96006 30.7091C6.98045 29.7295 7.33496 25.4629 8.00411 24.7916L27.6864 5.10936C28.3576 4.43811 29.4547 4.43811 30.1259 5.10936L33.5598 8.54322C34.231 9.21446 34.231 10.3115 33.5598 10.9828L13.8775 30.665C13.2063 31.3363 8.93756 31.6887 7.96006 30.7091Z" stroke="currentColor" strokeWidth="2.51718" strokeMiterlimit="10" strokeLinecap="round"/>
<path d="M24.3322 8.66278L29.9371 14.2698" stroke="currentColor" strokeWidth="2.51718" strokeMiterlimit="10" strokeLinecap="round"/>
</svg>

  );
}




